// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
import {axiosGet, axiosPost} from '@/store/http'
import {allUrl} from './router/allUrl'
import Public from './assets/public/js/index'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import '@/assets/images/icon/iconfont.css'
import md5 from 'js-md5'
Vue.use(VueAwesomeSwiper)
Vue.use(Public)
Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.prototype.$get = axiosGet
Vue.prototype.$post = axiosPost
Vue.prototype.$allUrl = allUrl
Vue.prototype.$md5 = md5

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  data: {
    eventHub: new Vue() // 用于事件的发射 和 接收
  },
  components: { App },
  template: '<App/>',
  created () {
    let userMsg = JSON.parse(window.sessionStorage.getItem('ysUserMsg'))
    if (userMsg) {
      this.$store.dispatch('update_userMsg', userMsg)
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js